module.exports = __webpack_public_path__ + "img/610dd46.jpg";